'use client';

import { createContext, FC, useContext, useEffect, useState } from 'react';
import { getDictionary, TDictionary, TLocale } from '../locales/dictionary';

export interface ILocaleContext {
  locale: TLocale;
  setLocale: (locale: TLocale) => void;
  dictionary: TDictionary;
}

export const LocaleContext = createContext<ILocaleContext>({
  locale: 'en',
  setLocale: () => {},
  dictionary: getDictionary('en'),
});

export const LocaleContextProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [locale, setLocale] = useState<TLocale>(() => {
    const saved = localStorage.getItem('locale');
    return (saved as TLocale) || 'en';
  });
  const [dictionary, setDictionary] = useState<TDictionary>(getDictionary(locale));

  useEffect(() => {
    setDictionary(getDictionary(locale));
    localStorage.setItem('locale', locale);
  }, [locale]);

  return (
    <LocaleContext.Provider
      value={{
        locale,
        setLocale,
        dictionary,
      }}
    >
      {children}
    </LocaleContext.Provider>
  );
};

export default function useLocale() {
  return useContext(LocaleContext);
}
